/* eslint-disable jsx-a11y/anchor-is-valid */
import { DeleteOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { updatePSGD6 } from 'pages/BillingProcess/slices';
import { deletePSG } from 'pages/BillingProcess/thunk';
import { useDispatch } from 'react-redux';

type Props = {
  data: any[];
  dataNew: any[];
  setDatePSG: any;
  statusBill: boolean | undefined;
};

const TableDataUser = ({ data, dataNew, setDatePSG, statusBill }: Props) => {
  const dispatch = useDispatch();
  const onClick = (index: any, i_id: string, position?: number) => {
    const dataSource = [...dataNew];
    const fIndex = dataNew.findIndex((f) => f.position === position);
    if (fIndex > -1) {
      dataSource.splice(fIndex, 1);
      setDatePSG(dataSource);
    } else {
      dispatch(updatePSGD6({ index: index }));
      dispatch(deletePSG(i_id));
    }
  };
  const columns: any = [
    {
      title: '対象年月',
      dataIndex: 'inspection_day',
      key: 'inspection_day',
      width: '20%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: 'ご利用者名',
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', background: 'rgba(246, 246, 246, 1)' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '備考',
      dataIndex: 'psg_remark',
      key: 'psg_remark',
      width: '60%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '',
      key: '1',
      dataIndex: 'button',
      width: '10%',
      align: 'center',
      render(text: string, row: any, index: number) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'center', borderLeft: '2px solid white' },
            className: 'standardFont',
          },
          children: (
            <div>
              {statusBill ? null : (
                <a
                  style={{
                    backgroundColor: '#F6F6F6',
                    width: '65px',
                    color: 'black',
                    border: 'none',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  }}
                  type="button"
                  onClick={() => onClick(index, row?.item_ref?.name?.i_id, row.position ?? -1)}
                >
                  削除
                  <DeleteOutlined style={{ marginBottom: '4px' }} />
                </a>
              )}
            </div>
          ),
        };
      },
    },
  ];
  return (
    <div>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        locale={{
          emptyText: <span style={{ color: 'gray' }}>利用なし</span>,
        }}
      />
    </div>
  );
};

export default TableDataUser;
